import React, { useState, useEffect } from "react";
import { useCMTag } from "api/api";
import moment from "moment";
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, CartesianGrid } from "recharts";
import Card from "components/cards/Card";
import { stdTimeOptions, limitedYarTimeOption } from "utility/timeOptions";
import { COP_Medium, TimeOption } from "model/Datatypes";

interface ICOP {
  tags: COP_Medium["tags"];
}

const COP: React.FC<ICOP> = ({ tags }) => {
  const [time, setTime] = useState<TimeOption>(limitedYarTimeOption);

  const [graphData, setgraphData] = useState<{ time: number; cop: number }[]>([]);
  const { cmData: copData, loading } = useCMTag(
    tags.COP,
    time.from,
    time.to,
    time.groupingsType,
    true
  );
  useEffect(() => {
    if (copData) {
      const cleaned = copData.points
        .filter((p) => p.value > 0 && p.value < 10)
        .map((p) => ({ time: p.time, cop: p.value }));
      setgraphData(cleaned);
    }
  }, [copData]);

  return (
    <>
      <div className="w-full h-full">
        <Card
          timeOptions={[...stdTimeOptions, limitedYarTimeOption]}
          timeSelected={time}
          onNewTimeSelected={(newTime) => setTime(newTime)}
          size="full"
          loading={loading}
        >
          <div className="text-base 2xl:text-4xl absolute top-4 2xl:top-10 left-12 2xl:left-16 z-30 font-medium text-gray-600">
            Performance (COP)
          </div>
          <div className="h-full w-full pt-12 pl-7 -ml-10 ">
            <COPGraphCard data={graphData} />
          </div>
        </Card>
      </div>
    </>
  );
};

export default COP;

const COPGraphCard: React.FC<{ data: { time: number; cop: number }[] }> = ({ data }) => {
  const momentFromat = "MMMM YYYY";

  return (
    <ResponsiveContainer width="100%" height={"95%"}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          interval={"preserveEnd"}
          tick={{ fontSize: "0.8rem", angle: -10 }}
          dataKey="time"
          tickMargin={10}
          type="category"
          tickFormatter={(val) => moment(val).format(momentFromat)}
        />
        <YAxis tick={{ fontSize: "0.8rem" }} />
        <Line type="monotone" dataKey="cop" stroke="#2FD2A6" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
};
